import angular from 'angular';
import _ from 'underscore';

function SettingsVenueSettingsCtrl($scope, $state, $window, $q, $stateParams, $timeout, sdkVenueService, sdkUtils, timezoneService, countryService, alertService, tagService, formHelpersService, mapperService, visibilityHelpersService, ERROR_MESSAGES, venueService) { //eslint-disable-line
  $scope.venuePromise = sdkVenueService.readById($stateParams.venueId);

  $scope.loading = true;
  $scope.saveVenue = _saveVenue;

  $q.all([
      $scope.venuePromise
    ])
    .then(results => {
      $scope.venue = results[0];

      $scope.venueEditForm = mapperService.mapApiToVenue(angular.copy($scope.venue), $scope.tags, $scope.countries);
    })
    .finally(() => {
      $scope.loading = false;
    });

  function _saveVenue(form, $event) {
    if (!form) throw new Error('form is required');
    if ($event) $event.preventDefault();

    $scope.submitted = true;
    $scope.errors = [];

    if (!form.$valid) {
      $scope.errors = formHelpersService.getFormErrors(form);
      return;
    }

    const changedValues = formHelpersService.getChangedFormValues(form);

    const venueUpdateData = mapperService.mapVenueToApi(changedValues, $scope.tags);

    $scope.savingVenue = true;

    sdkVenueService.updateById($scope.venue.id, venueUpdateData)
      .then(result => {
        _.extend($scope.venue, result);

        $scope.venueEditForm = mapperService.mapApiToVenue($scope.venue, $scope.tags, $scope.countries);

        const currentVenue = venueService.getCurrentVenue();

        if (currentVenue.id === result.id) {
          venueService.setCurrentVenue(result);
        }

        alertService.success('Venue updated');
      })
      .catch(error => alertService.error(sdkUtils.getErrorFromResponse(error)))
      .finally(() => {
        $scope.savingVenue = false;
        $scope.submitted = false;

        form.$setUntouched(); //reset the form values
      });
  }
}

SettingsVenueSettingsCtrl.$inject = [
  '$scope',
  '$state',
  '$window',
  '$q',
  '$stateParams',
  '$timeout',
  'jsSdk.venue',
  'jsSdk.utils',
  'timezoneService',
  'countryService',
  'alertService',
  'jsSdk.tag',
  'formHelpersService',
  'mapperService',
  'visibilityHelpersService',
  'ERROR_MESSAGES',
  'venueService'
];

export default SettingsVenueSettingsCtrl;



// WEBPACK FOOTER //
// ./src/components/settingsVenueBusinessHours/settingsVenueBusinessHoursCtrl.js